// extracted by mini-css-extract-plugin
export var container = "_co-0";
export var infoIcon = "_co-2";
export var internalLabel = "_co-3";
export var titleRowCol = "_co-1";